module.exports = __webpack_public_path__ + "static/media/bix.47583579.svg";